import { render } from "./CreateCoursePage.vue?vue&type=template&id=2b967a02&ts=true"
import script from "./CreateCoursePage.vue?vue&type=script&lang=ts"
export * from "./CreateCoursePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__